import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';

@Component({
    selector: 'app-group-assignment',
    imports: [],
    templateUrl: './group-assignment.component.html',
    styleUrl: './group-assignment.component.scss'
})
export class GroupAssignmentComponent {
 constructor(private titleService:Title, private themeService:ThemeService
      
 ) {
   this.titleService.setTitle("Grupos - Asignación");
   this.themeService.setTitle("Asignación de Grupos");

 }
}
